<div class="flex flex-col w-full p-6 tab-frame">

    <div class="w-full mb-8">
        <div class="flex justify-between mt-4 mb-10">
            <div class="text-center">
                <div class="text-2xl text-primary"><b>Xmas Tree</b></div>
            </div>

            <div class="flex justify-end">
                <div class="flex items-center">
                    <div [ngClass]="{'font-bold': !isReplace}">Edit</div>
                    <input type="checkbox" class="toggle bg-primary mx-2" [(ngModel)]="isReplace"
                        [disabled]="disabledToggle" />
                    <div [ngClass]="{'font-bold': isReplace}">Replace</div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-4 gap-8">
            <mat-label class="flex items-center"> Installed Date </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput [matDatepicker]="picker" [(ngModel)]="xmasTreeForm.installedDate" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-label class="flex items-center"> Part Number </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput placeholder="" [(ngModel)]="xmasTreeForm.partNo">
            </mat-form-field>

            <mat-label class="flex items-center"> Size </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput placeholder="" type="number" [(ngModel)]="xmasTreeForm.sizeIn">
                <span matTextSuffix>inches</span>
            </mat-form-field>

            <!-- <mat-label class="flex items-center"> Status </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput placeholder="" [(ngModel)]="xmasTreeForm.status">
            </mat-form-field> -->

            <mat-label class="flex items-center"> Equipment Brand / OEM </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput placeholder="" [(ngModel)]="xmasTreeForm.equipmentBrand">
            </mat-form-field>

            <mat-label class="flex items-center"> Model </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput placeholder="" [(ngModel)]="xmasTreeForm.model">
            </mat-form-field>

            <mat-label class="flex items-center"> Rating </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput placeholder="" type="number" [(ngModel)]="xmasTreeForm.ratingPsi">
                <span matTextSuffix>psi</span>
            </mat-form-field>

            <mat-label class="flex items-center"> Remarks </mat-label>
            <mat-form-field class="no-bottom-gap col-span-3">
                <textarea matInput placeholder="" [(ngModel)]="xmasTreeForm.remark"></textarea>
            </mat-form-field>

            <div class="divider col-span-4"> Tree Cap Connection Details</div>

            <mat-label class="flex items-center"> Tree Cap Connection </mat-label>
            <mat-form-field class="no-bottom-gap">
                <mat-select matNativeControl [(ngModel)]="xmasTreeForm.treecapConn"
                    (selectionChange)="treecapConnChange($event)">
                    <mat-option value="BOWEN"> BOWEN </mat-option>
                    <mat-option value="OTIS"> OTIS </mat-option>
                    <mat-option value="OTHERS"> OTHERS </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-label class="flex items-center"> If Others </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput placeholder="" [disabled]="xmasTreeForm.treecapConn !== 'OTHERS'"
                    [(ngModel)]="xmasTreeForm.treecapConnRemarks">
            </mat-form-field>

            <mat-label class="flex items-center"> Size </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput placeholder="" type="number" step="0.01" min="0"
                    [(ngModel)]="xmasTreeForm.treeCapConnSize" (blur)="formatDecimal(xmasTreeForm.treeCapConnSize)">
                <span matTextSuffix>inches</span>
            </mat-form-field>

            <mat-label class="flex items-center"> Thread </mat-label>
            <mat-form-field class="no-bottom-gap">
                <input matInput placeholder="" [(ngModel)]="xmasTreeForm.treeCapConnThread">
            </mat-form-field>

            <mat-label class="flex items-center"> Description </mat-label>
            <mat-form-field class="no-bottom-gap col-span-3">
                <textarea matInput placeholder="" [(ngModel)]="xmasTreeForm.treeCapDescription"></textarea>
            </mat-form-field>
        </div>
    </div>

    <div class="flex justify-end">
        <button class="btn btn-primary" [disabled]="disabledSave()" (click)="save()"> {{ isReplace ? 'Save' : 'Update'
            }} </button>
    </div>
</div>